import React from 'react';
import LandingNavbar from '../components/landing/LandingNavbar';
import HeroSection from '../components/landing/HeroSection';
import AboutSection from '../components/landing/AboutSection';
import HowItWorks from '../components/landing/HowItWorks';
import AnalyticsPreview from '../components/landing/AnalyticsPreview';
import FinalCTA from '../components/landing/FinalCTA';
import Footer from '../components/landing/Footer';

const GuideBot = React.lazy(() => import('../components/ui/GuideBot'));

const LandingPage: React.FC = () => {
  return (
    <div className="landing-layout">
      <LandingNavbar />
      <main>
        <HeroSection />
        <AboutSection />
        <HowItWorks />
        <AnalyticsPreview />
        <FinalCTA />
      </main>
      <Footer />
      <React.Suspense fallback={null}>
        <GuideBot />
      </React.Suspense>
    </div>
  );
};

export default LandingPage;
